import React, { useEffect, useState } from 'react'

export const ChuGiaiHanhChinhHuyen = (props) => {
    const [listChuGiais, setListChuGiai] = useState([]);
    useEffect(()=>{
        setListChuGiai(props.listChuGiais);
    }, [props.listChuGiais]);
    const clickRow = (item) => {
        // item.Checked = !item.Checked;
        // setListChuGiai([...listChuGiais]);
        // props.clickChuGiai(listChuGiais.filter(x => x.Checked).map(x => x.maHienTrang).join(','));
    }
    return (
        <table className="table table-bordered tb-chu-giai" width="100%">
            <thead>
                <tr>
                    {/* <th rowSpan="2" className="col-checkbox"></th> */}
                    <th rowSpan="2" className="mau-ky-hieu">Mã huyện Màu sắc</th>
                    <th colSpan="17">HÀNH CHÍNH HUYỆN</th>
                </tr>
                <tr>
                    <th>Tên huyện</th>
                    <th>Năm</th>
                    <th>Diện tích(Km2)</th>
                    <th>Dân số(1000)</th>
                    <th>Mật độ</th>
                    <th>Số phường xã</th>
                    <th>Thị trấn</th>
                </tr>
            </thead>
            <tbody>
                {
                    listChuGiais?.map((item, key) => {
                        return (
                            <tr onClick={() => clickRow(item)} key={key}>
                                {/* <td className="col-checkbox">
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" checked={item.Checked} readOnly />
                                    </div>
                                </td> */}
                                <td className="mau-ky-hieu">
                                    <div style={{backgroundColor: item.maMau}}>
                                        <span>{item.maHuyen}</span>
                                    </div>
                                </td>
                                <td>{item.tenHuyen}</td>
                                <td className="text-center">{item.nam}</td>
                                <td className="text-right">{item.DienTichKm2}</td>
                                <td className="text-right">{item.tbDanSo1000}</td>
                                <td className="text-right">{item.mdDanSoKm2}</td>
                                <td className="text-right">{item.PhuongXa}</td>
                                <td className="text-right">{item.ThiTran}</td>
                            </tr>
                        )
                    })
                }
            </tbody>
        </table>
    )
}
